import clsx from "clsx";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faEnvelope, faCog } from '@fortawesome/free-solid-svg-icons';
import Initials from "../../components/Initials";
import { DeleteButton, DisableUserButton, EditButton, EnableUserButton } from "../../components/TableActionButtons";

export const getUsersTableConfig = (handleEdit, handleDelete, handleEnableUser, handleDisableUser) => [
    {
        header: () => (
            <span className="flex items-center">
                <FontAwesomeIcon icon={faUser} className="w-4 h-4 mr-2" />
                FULL NAME
            </span>
        ),
        accessorKey: 'fullname',
        cell: ({ row }) => (
            <div className="text-left flex items-center gap-3">
                <Initials firstName={row.original.firstname} lastName={row.original.lastname} />
                {`${row.original.firstname} ${row.original.lastname}`}
            </div>
        )
    },
    {
        header: () => (
            <span className="flex items-center">
                <FontAwesomeIcon icon={faEnvelope} className="w-4 h-4 mr-2" />
                EMAIL
            </span>
        ),
        accessorKey: 'email',
        cell: ({ row }) => <div className="text-left">{row.original.email}</div>
    },
    {
        header: () => (
            <span className="flex items-center">
                <FontAwesomeIcon icon={faUser} className="w-4 h-4 mr-2" />
                ROLE
            </span>
        ),
        accessorKey: 'role',
        cell: ({ row }) => <div className="text-left">{row.original.role}</div>
    },
    {
        header: () => (
            <span className="flex items-center">
                <FontAwesomeIcon icon={faUser} className="w-4 h-4 mr-2" />
                STATUS
            </span>
        ),
        accessorKey: 'blocked',
        cell: ({ row }) => (
            <div className="text-left">
                <span className={clsx(
                    "px-2 py-1 rounded-full text-xs font-medium",
                    row.original.blocked 
                        ? "bg-red-100/20 text-red-700" 
                        : "bg-green-200/30 text-green-900"
                )}>
                    {row.original.blocked ? 'Inactive' : 'Active'}
                </span>
            </div>
        )
    },

    {
        header: () => (
            <span className="flex items-center justify-center">
                <FontAwesomeIcon icon={faCog} className="w-4 h-4 mr-2" />
                ACTIONS
            </span>
        ),
        id: 'actions',
        cell: ({ row }) => (
            <div className="flex items-center justify-center gap-3">
                <EditButton onClick={() => handleEdit(row.original)} row={row} />
                <DeleteButton onClick={handleDelete} row={row} />
                {row.original.blocked ? (
                    <EnableUserButton onClick={handleEnableUser} row={row} />
                ) : (
                    <DisableUserButton onClick={handleDisableUser} row={row} />
                )}
            </div>
        )
    }
];
